
import { isNullOrWhiteSpace, printf, toText, split } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { item, equalsWith } from "../../fable_modules/fable-library-js.5.3.0/Array.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { tryParse } from "../../fable_modules/fable-library-js.5.3.0/Int32.js";
import { FSharpRef } from "../../fable_modules/fable-library-js.5.3.0/Types.js";

/**
 * Parse "HH:mm" string to minutes since midnight, returns 0 on invalid/empty input
 */
export function parseTimeToMinutes(time) {
    let m, h;
    const matchValue = split(time, [":"], undefined, 0);
    if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 2)) {
        const mStr = item(1, matchValue);
        let matchValue_1;
        let outArg = 0;
        matchValue_1 = [tryParse(item(0, matchValue), 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
            outArg = (v | 0);
        })), outArg];
        let matchValue_2;
        let outArg_1 = 0;
        matchValue_2 = [tryParse(mStr, 511, false, 32, new FSharpRef(() => (outArg_1 | 0), (v_1) => {
            outArg_1 = (v_1 | 0);
        })), outArg_1];
        let matchResult;
        if (matchValue_1[0]) {
            if (matchValue_2[0]) {
                if ((m = (matchValue_2[1] | 0), (h = (matchValue_1[1] | 0), (((h >= 0) && (h < 24)) && (m >= 0)) && (m < 60)))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return ((matchValue_1[1] * 60) + matchValue_2[1]) | 0;
            default:
                return 0;
        }
    }
    else {
        return 0;
    }
}

/**
 * Convert minutes since midnight to "HH:mm" string
 */
export function minutesToTimeString(minutes) {
    const m = (((minutes % 1440) + 1440) % 1440) | 0;
    const arg = ~~(m / 60) | 0;
    const arg_1 = (m % 60) | 0;
    return toText(printf("%02d:%02d"))(arg)(arg_1);
}

/**
 * Compute the offset in minutes from start time to reminder time, normalized modulo 24h
 */
export function computeOffset(startTime, reminderTime) {
    const startMin = parseTimeToMinutes(startTime) | 0;
    return ((((parseTimeToMinutes(reminderTime) - startMin) % 1440) + 1440) % 1440) | 0;
}

/**
 * Format "HH:mm" string to 12-hour AM/PM display (e.g. "09:00" -> "9:00 AM")
 * Returns the raw string as-is when it cannot be parsed (including empty input)
 */
export function formatTimeAmPm(time) {
    let minute, hour;
    const matchValue = split(time, [":"], undefined, 0);
    if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 2)) {
        const mStr = item(1, matchValue);
        let matchValue_1;
        let outArg = 0;
        matchValue_1 = [tryParse(item(0, matchValue), 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
            outArg = (v | 0);
        })), outArg];
        let matchValue_2;
        let outArg_1 = 0;
        matchValue_2 = [tryParse(mStr, 511, false, 32, new FSharpRef(() => (outArg_1 | 0), (v_1) => {
            outArg_1 = (v_1 | 0);
        })), outArg_1];
        let matchResult;
        if (matchValue_1[0]) {
            if (matchValue_2[0]) {
                if ((minute = (matchValue_2[1] | 0), (hour = (matchValue_1[1] | 0), (((hour >= 0) && (hour < 24)) && (minute >= 0)) && (minute < 60)))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const hour_1 = matchValue_1[1] | 0;
                const period = (hour_1 < 12) ? "AM" : "PM";
                const displayHour = ((hour_1 === 0) ? 12 : ((hour_1 > 12) ? (hour_1 - 12) : hour_1)) | 0;
                return toText(printf("%d:%02d %s"))(displayHour)(matchValue_2[1])(period);
            }
            default:
                return time;
        }
    }
    else {
        return time;
    }
}

/**
 * Format "HH:mm" string to 12-hour AM/PM display, returning a placeholder for empty/whitespace input.
 * Suitable for locked field display where blank values should show "Not set".
 */
export function formatTimeAmPmOrPlaceholder(time) {
    if (isNullOrWhiteSpace(time)) {
        return "Not set";
    }
    else {
        return formatTimeAmPm(time);
    }
}

/**
 * Apply an offset to a start time, wrapping around 24h
 */
export function applyOffset(offsetMinutes, startTime) {
    return minutesToTimeString(((parseTimeToMinutes(startTime) + offsetMinutes) + 1440) % 1440);
}

//# sourceMappingURL=TimeHelpers.js.map
